import React, {useEffect, useState} from "react";
import MarkdownViewer from "./MarkdownViewer";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import styles from "./Markdown.module.scss";
import MDEditor from "@uiw/react-md-editor";
import CreateIcon from '@mui/icons-material/Create';

type Props = {
  title?: string
  value: string | undefined
  onChange: (value: string | undefined) => void
}

function MarkdownPreviewWithEditDialog({title, value, onChange}: Props) {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editValue, setEditValue] = useState<string | undefined>();

  useEffect(() => {
    setEditValue(value);
  }, [value]);
  const onClose = () => setEditModalOpen(false);

  const onSave = () => {
    onChange(editValue);
    setEditModalOpen(false);
  }

  return (
      <>
        <Box onClick={_ => setEditModalOpen(true)} className={styles["clickable-box"]}>
          <CreateIcon className={styles["pencil-icon"]}/>
          <MarkdownViewer value={value}/>
        </Box>
        <Dialog open={editModalOpen} onClose={onClose} maxWidth="md" fullWidth={true}>
          <DialogTitle>{title ?? "Text ändern"}</DialogTitle>
          <DialogContent sx={{paddingTop: "10px !important"}}>
            <MDEditor value={editValue || ""} onChange={setEditValue} height={350}/>
          </DialogContent>
          <DialogActions
              aria-label="outlined primary button group">
            <Button variant="contained" onClick={onClose}>Abbrechen</Button>
            <Button variant="contained" onClick={onSave}>Übernehmen</Button>
          </DialogActions>
        </Dialog>
      </>
  );
}

export default MarkdownPreviewWithEditDialog;